import script from "./UserNewTripPage.vue?vue&type=script&setup=true&lang=js"
export * from "./UserNewTripPage.vue?vue&type=script&setup=true&lang=js"

import "./UserNewTripPage.vue?vue&type=style&index=0&id=72ca6cdc&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-72ca6cdc"]])

export default __exports__